import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span>© {new Date().getFullYear()} Escuela de Posgrado – UNSM Tarapoto</span>
        <span>Soporte: epg@unsm.edu.pe</span>
      </div>
    </footer>
  );
}
